// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"78":"chunk_admin-wfs-search-channel","623":"chunk_file-layerlist","950":"chunk_content-editor"}[chunkId] + "/oskari.min.css";
};